<div class="container mx-auto p-4">
  <h1 class="text-2xl font-bold mb-4">Shopping Cart</h1>

  <div *ngIf="cartItems.length === 0" class="text-center text-gray-500">
    Your cart is empty.
  </div>

  <div class="max-w-6xl mx-auto mt-10 px-4">
    <div class="overflow-x-auto">
      <table class="min-w-full table-auto border-t border-gray-200">
        <thead>
          <tr class="bg-gray-100 text-left text-sm text-gray-700">
            <th class="p-3">Product</th>
            <th class="p-3">Unit Price</th>
            <th class="p-3">Size</th>
            <th class="p-3">Quantity</th>
            <th class="p-3">Subtotal</th>
            <th class="p-3 text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of cartItems" class="border-b">
            <td class="flex items-center p-3 space-x-4">
              <img [src]="environment.apiBaseUrl+item.product.imagePath" alt="product image" class="w-16 h-16 rounded shadow-sm border" />
              <a [routerLink]="['/admin/product', item.product.id]" class="text-blue-600 hover:underline font-medium">
                {{ item.product.name }}
              </a>
            </td>
            <td class="p-3 text-sm text-gray-600">
              <span class="line-through text-gray-400 mr-1">৳ {{ item.product.price }}</span>
              <span class="text-black font-semibold">৳ {{ item.product.price }}</span>
            </td>
            <td class="p-3">
              <input type="text" [value]="item.size" class="px-2 py-1 border rounded w-28 text-sm" disabled />
            </td>
            <td class="p-3">
              <input type="number"
                     [(ngModel)]="item.quantity"
                     min="1"
                     class="w-16 px-2 py-1 border rounded text-sm text-center"
                     (change)="updateQuantity(item.product.id, item.quantity)" />
            </td>
            <td class="p-3 text-sm">
              <span class="line-through text-gray-400 mr-1">৳ {{ item.product.price * item.quantity }}</span>
              <span class="text-black font-semibold">৳ {{ item.product.price * item.quantity }}</span>
            </td>
            <td class="p-3 text-right">
              <!--<button class="text-blue-600 text-sm hover:underline mr-3" (click)="addAnotherSize(item)">+ Add another Size</button>-->
              <button class="text-red-600 hover:bg-red-100 p-2 rounded" (click)="removeItem(item.id)">
                🗑
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center mt-10">
      <h3 class="text-2xl font-semibold mb-2">Total Amount (৳): <span class="text-green-600">{{ totalAmount }}</span></h3>

      <div class="mt-6 space-x-4">
        <button class="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded font-medium"
                (click)="checkout()"
                [disabled]="cartItems.length === 0">
          Checkout
        </button>
        <a routerLink="/" class="bg-yellow-400 hover:bg-yellow-500 text-white px-6 py-2 rounded font-medium inline-block">
          Continue Shopping
        </a>
      </div>
    </div>
  </div>
</div>
